module.exports = __webpack_public_path__ + "static/dl2-stay-human_og-image-38e0bc565797664b1d52a83bd6c741ad.jpg";